<template>
    <div class="main">
        <div class="left">
            <Spin fix v-if="loading"></Spin>
            <e-charts v-else :options="options" autoresize />
        </div>
        <div class="right">
            <div class="choose">
                <Select v-model="year">
                    <Option
                        v-for="item in yearList"
                        :value="item"
                        :key="item.id"
                        >{{ item + '年' }}</Option
                    >
                </Select>
            </div>
        </div>
    </div>
</template>

<script>
import LineMixin from '@/views/common/m-chart-line'
import { yearFeeTrend } from '@/api/ems-stats'
import dayjs from 'dayjs'
// 1是收入  2是支出  结余是收入减支出
export default {
    mixins: [LineMixin],
    data() {
        return {
            loading: false,
            year: new Date().getFullYear().toString(),
            xList: [],
            income: [], //收入
            disburse: [], //支出
            over: [], //结余
            yearList: [
                new Date().getFullYear().toString(),
                (new Date().getFullYear() - 1).toString(),
                (new Date().getFullYear() - 2).toString(),
                (new Date().getFullYear() - 3).toString(),
            ],
        }
    },
    computed: {
        options() {
            return {
                title: {
                    text: '年度财务收支走势',
                    left: 18,
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    },
                },
                tooltip: {
                    trigger: 'axis',
                },

                legend: {
                    data: ['收入', '支出', '结余'],
                    bottom: 10,
                },
                color: [
                    ' rgb(242, 148, 148)',
                    ' rgb(93, 212, 202)',
                    ' rgb(245, 154, 35)',
                ],
                xAxis: {
                    type: 'category',
                    data: this.xList,
                    axisPointer: {
                        type: 'shadow',
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#eeeeee',
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#aaa',
                        },
                    },
                },

                yAxis: [
                    {
                        type: 'value',
                        name: '单位：元',
                        nameTextStyle: {
                            color: 'rgb(153, 153, 153)',
                            fontSize: 12,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#eeeeee',
                            },
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#aaa',
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#eeeeee',
                            },
                        },
                    },
                    {
                        type: 'value',
                        nameTextStyle: {
                            color: 'rgb(153, 153, 153)',
                            fontSize: 12,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#eeeeee',
                            },
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#aaa',
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#eeeeee',
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: '收入',
                        type: 'bar',
                        data: this.income,
                        barWidth: 15,
                    },
                    {
                        name: '支出',
                        type: 'bar',
                        data: this.disburse,
                        barWidth: 15,
                    },
                    {
                        name: '结余',
                        type: 'line',
                        data: this.over,
                    },
                ],
            }
        },
    },
    methods: {
        fetch() {
            this.loading = true
            yearFeeTrend(this.year).then((res) => {
                this.setPageData(res.data)
                this.loading = false
            })
        },
        setPageData(data) {
            this.xList = data.monthList
            let income = []
            let disburse = []
            let over = []

            this.xList.forEach((y, i) => {
                const arr = data.list.filter((v) => y === v.date)
                const incomeItem = arr.find((v) => v.flowType === '1')
                const disburseItem = arr.find((v) => v.flowType === '2')
                income.push(incomeItem ? incomeItem.amount / 100 : 0)
                disburse.push(disburseItem ? disburseItem.amount / 100 : 0)
                over.push(income[i] - disburse[i])
            })

            this.income = income
            this.disburse = disburse
            this.over = over
        },
    },
    created() {
        this.fetch()
    },
    watch: {
        year(val, oldval) {
            if (val == oldval) {
            } else {
                this.fetch()
            }
        },
    },
}
</script>

<style lang="less" scoped>
.main {
    display: flex;
    position: relative;
}
.left {
    width: 100%;
    height: 100%;
    padding-top: 10px;
    position: absolute;
}
.right {
    position: absolute;
    right: -5px;
    top: -5px;
    width: 100px;
    height: 100%;
}
.choose {
    margin-top: 20px;
    margin-right: 20px;
}
</style>
